import {
  pathOr
} from 'ramda'

const getTargetChecked = pathOr(false,['target', 'checked'])

export default getTargetChecked